enum BrinkApiServer {
  Sandbox = 1,
  Api = 101,
  Api2 = 2,
  Api3 = 3,
  Api4 = 4,
  Api5 = 5,
  Api6 = 6,
  Api7 = 7,
  Api8 = 8,
  Api9 = 9,
  Api10 = 10,
  Api11 = 11,
  Api12 = 12,
  Api14 = 14,
  Api15 = 15,
  Api19 = 19,
  Api20 = 20,
  Api21 = 21,
  Api22 = 22,
  Api23 = 23,
  Api24 = 24,
  Api25 = 25,
  Api26 = 26,
  Api27 = 27,
  Api28 = 28,
  Api29 = 29,
  Api30 = 30,
  Api31 = 31,
  Api32 = 32,
  Api33 = 33,
  Api34 = 34,
  Api35 = 35,
  Api36 = 36,
  Api37 = 37,
  Api38 = 38,
  Api39 = 39,
  Api40 = 40,
  Api41 = 41,
  Api42 = 42,
  Api43 = 43,
  Api44 = 44,
  Api45 = 45,
  Api46 = 46,
  Api47 = 47,
  Api48 = 48,
  Api49 = 49,
  Api50 = 50,
  ApiSales = 10001,
  ApiChannel = 10002,
  ZaxbysUatLab = 10003,
  ApiEarlyExposure = 10004,
}

export { BrinkApiServer };
